import { getRequest, postRequest } from '../../../../services/httpService';
import { IssueItemDetail } from '../Issue/Issue.helper';
import { GetIndentListParams, StatusCounts } from '../stockTransfer.helper';




export interface ReceiveProspectiveListResponse {
  id: number;
  clinic: string;
  clinic_label: string
  from_store: string;
  from_store_label: string;
  to_store: string;
  to_store_label: string;
  to_clinic_label: string;
  expected_date: string; // YYYY-MM-DD
  created_on: string;    // ISO date string
  issue_no: string;
  indent_no: string;
  issue_type_label?: string;
  indent_date: string; // YYYY-MM-DD
  issue_date: string; // YYYY-MM-DD
  status: 'STORE' | string;
  pr_no: string | null;
  issue_type: 'INDENT' | string;
  statuses: 'STORE' | string;
  total_amount: string;
  patient: null | {
    id: number;
    first_name: string;
    last_name: string;
  };
  remark: string | null;
  indent_remark: string | null;
  cancel_remark: string | null;
  issue_item_details: IssueItemDetail[];
}

export interface ReceivedListResponse {
  id: number;
  clinic: string;
  clinic_label: string;
  from_store: string;
  from_store_label: string;
  from_clinic?: string;
  from_clinic_label?: string;
  to_store: string;
  to_store_label: string;
  expected_date: string; // YYYY-MM-DD
  created_on: string;    // ISO date
  receive_no: string;
  received_date: string; // YYYY-MM-DD
  indent_date: string; // YYYY-MM-DD
  issue_date: string; // YYYY-MM-DD
  issue_no: string;
  indent_no: string;
  total_amount: string;
  created_by?: string;
  status: 'STORE' | string;
  patient: null | {
    id: number;
    first_name: string;
    last_name: string;
  };
  to_store_id: string;
  remark: string | null;
  cancel_remark: string | null;
  receive_item_details: IssueItemDetail[];
}

export interface ReceiveProspectiveListApiResponse {
  objects: ReceiveProspectiveListResponse[];
  status_counts: StatusCounts;
  meta?: {
    total_count?: number;
    limit?: number;
    offset?: number;
  };
}

export interface ReceivedListApiResponse {
  objects: ReceivedListResponse[];
  status_counts: StatusCounts;
  meta?: {
    total_count?: number;
    limit?: number;
    offset?: number;
  };
}

export interface ReceiveDetailPayload {
  issue_detail_id: number;
  received_qty: number;
  base_mrp: string;
  base_cost_price: string;
  total_base_cost_price: string;
  total_mrp_cost_price: string;
}

export interface CreateReceivePayload {
  items: ReceiveDetailPayload[];
  remark?: string;
}

export type CreateReceiveResponse = {
  message: string;
  receive_no: string;
}


export function getReceiveProspectiveList(params: GetIndentListParams = {}): Promise<ReceiveProspectiveListApiResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });
  const url = `issue/prospective/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}


export function getReceivedList(params: GetIndentListParams = {}): Promise<ReceivedListApiResponse> {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value));
    }
  });
  const url = `receive/?${query.toString()}`;
  return getRequest(url, { responseType: 'json' });
}



export function CreateReceive(id: number | string, data: CreateReceivePayload): Promise<CreateReceiveResponse> {
  const url = `issue/${id}/create-receive/`;
  return postRequest(url, data, { responseType: 'json' });
}